

module.exports = __webpack_require__.stylable.create(
    "ProductLineItemOverride2642977540",
    {"classes":{"root":"ProductLineItemOverride2642977540__root","myPrice":"ProductLineItemOverride2642977540__myPrice","myOptions":"ProductLineItemOverride2642977540__myOptions","myRemove":"ProductLineItemOverride2642977540__myRemove","myQuantity":"ProductLineItemOverride2642977540__myQuantity"},"vars":{},"stVars":{"PopoverBackgroundColor":"#d6453d","textColor":"'\"color(--cart_textColor)\"'","bodyFont":"'\"font({theme: 'cart_textFontStyle', size: '12px', lineHeight: '1'})\"'","backgroundColor":"'\"color(--cart_background)\"'","disabledColor":"#C7C7C7"},"keyframes":{}},
    "",
    16,
    "ProductLineItemOverride2642977540",
    null
);
